import { useTheme } from "@/components/ThemeContext";
import { motion } from "framer-motion";
import { Sun, Moon } from "lucide-react";

const springTransition = { type: "spring", stiffness: 500, damping: 30 };
const starInitial = { opacity: 0, scale: 0 };
const starAnimate = { opacity: 1, scale: 1 };

export default function ThemeToggle() {
  const { isDark, toggle } = useTheme();

  return (
    <button
      data-testid="theme-toggle-btn"
      onClick={toggle}
      aria-label={isDark ? "Passa alla modalità giorno" : "Passa alla modalità notte"}
      className="relative w-16 h-8 rounded-full p-1 transition-colors duration-500 focus:outline-none"
      style={{
        background: isDark
          ? "linear-gradient(135deg, #1a1a2e 0%, #0A0A0A 100%)"
          : "linear-gradient(135deg, #87CEEB 0%, #E8D5A3 100%)",
        border: isDark ? "1px solid rgba(201,166,70,0.4)" : "1px solid rgba(201,166,70,0.6)",
      }}
    >
      <motion.div
        layout
        transition={springTransition}
        className="w-6 h-6 rounded-full flex items-center justify-center shadow-lg"
        style={{
          background: isDark ? "#C9A646" : "#FDB813",
          marginLeft: isDark ? "0px" : "auto",
        }}
      >
        {isDark ? (
          <Moon className="w-3.5 h-3.5 text-[#0A0A0A]" strokeWidth={2} />
        ) : (
          <Sun className="w-3.5 h-3.5 text-[#0A0A0A]" strokeWidth={2} />
        )}
      </motion.div>

      {isDark && (
        <>
          <motion.div
            initial={starInitial}
            animate={starAnimate}
            transition={{ delay: 0.2 }}
            className="absolute top-1.5 right-3 w-1 h-1 bg-white rounded-full"
          />
          <motion.div
            initial={starInitial}
            animate={starAnimate}
            transition={{ delay: 0.3 }}
            className="absolute top-3 right-5 w-0.5 h-0.5 bg-white/70 rounded-full"
          />
        </>
      )}
    </button>
  );
}
